import {
  OffsetDays,
  GetDaysInZoom,
  GetStartDateForPlannerDate,
  ToDateString,
  getCellWidthForZoom,
  getYearWeekNumber,
} from "../../../lib/DateUtils";
import GenerateMonthRow from "../lib/GenerateMonthRow";
import DateCell from "./DateCell";
import TeambookSortingTypes from "../../default_components/TeambookSortingTypes";
import { shallow } from "zustand/shallow";
import { useDateStore, useZoomStore } from "../../../stores/planner";
import { PLANNER_USER_WIDTH } from "../../../lib/PlannerUtils";
import { isWeekend } from "date-fns";
import { MonthSeparator } from "../users_planner/components/MonthSeparator";
import { DateTime } from "luxon";
import { MonthName } from "./MonthName";
import PropTypes from "prop-types";

const DateRow = ({ allRowsCreation, weekendsHidden, weekendStart, userOrder, changeOrder }) => {
  const [zoom] = useZoomStore((state) => [state.zoom], shallow);
  const [date] = useDateStore((state) => [state.date], shallow);

  let days = GetDaysInZoom(zoom);

  const firstPlannerDate = GetStartDateForPlannerDate(date, zoom);
  let role = localStorage.getItem("tb-role");

  let rows = [];
  let monthRow = GenerateMonthRow(zoom, firstPlannerDate, days, weekendsHidden, weekendStart, 160, date);

  const weekInRange = Math.floor(
    DateTime.fromJSDate(firstPlannerDate)
      .plus({ days: GetDaysInZoom(zoom) })
      .diff(DateTime.fromJSDate(firstPlannerDate), "weeks").weeks
  );

  rows.push(
    <div className="date-row__filter-cell" style={{ width: PLANNER_USER_WIDTH }} key={`filter-cell-first-cell`}>
      <div className="filter-cell">
        {["admin", "planner", "regular", "self_planner"].includes(role) && (
          <TeambookSortingTypes
            filterOrder={userOrder !== "null" ? userOrder : "default"}
            setFilterOrder={changeOrder}
            sortingTypes={["user", "department", "default"]}
          />
        )}
      </div>
    </div>
  );

  if (zoom === 1) {
    for (let i = 7; i < 23; i++) {
      rows.push(
        <div
          className="date-row__hours"
          style={{ borderRight: i === 22 ? "unset" : "1px solid var(--stroke)" }}
          key={`date-cell-${ToDateString(date)}-${i}`}
        >
          <p>{i}:00</p>
        </div>
      );
    }
  } else {
    for (let i = 1; i < days + 1; i++) {
      let newDate = OffsetDays(firstPlannerDate, i - 1);
      const isPast = DateTime.fromJSDate(newDate).startOf("day").ts < DateTime.now().startOf("day").ts;
      const isCurrent = DateTime.fromJSDate(newDate).startOf("week").ts === DateTime.now().startOf("week").ts;
      const todayIsWeekend = isWeekend(new Date());

      const displayAsRedText = !weekendsHidden && (weekendStart === i % 7 || (weekendStart + 1) % 7 === i % 7);

      if (weekendsHidden && (weekendStart === i % 7 || (weekendStart + 1) % 7 === i % 7)) {
        if (isWeekend(newDate)) {
          rows.push(
            <div
              style={{ width: 10 }}
              className={`date-row__weekend-cell__container date-cell-header ${
                isPast ? "date-row__weekend-cell__container__past" : ""
              } ${newDate.getDay() === 0 ? "date-row__weekend-cell__container__sunday" : ""}`}
              data-date={ToDateString(newDate)}
              key={`date-row-call-${i}`}
            >
              <div
                className="date-row__weekend-cell"
                style={{
                  borderRight: newDate.getDay() === 0 && isPast && "1px solid var(--stroke)",
                  background: isCurrent && todayIsWeekend ? "var(--background-2) !important" : "unset",
                  borderLeft:
                    isCurrent && todayIsWeekend && newDate.getDay() === 6
                      ? "1px solid var(--text-3) !important"
                      : newDate.getDay() === 0 && "unset",
                }}
                key={`date-cell-${ToDateString(newDate)}`}
              ></div>
              {(weekendStart + 1) % 7 === i % 7 && i !== days && (
                <div className="date-row__weekend-cell__right-border" />
              )}
            </div>
          );
        }
      } else {
        rows.push(
          <DateCell
            key={`date-cell-${ToDateString(newDate)}`}
            date={newDate}
            allRowsCreation={allRowsCreation}
            displayAsRedText={displayAsRedText}
            weekendsHidden={weekendsHidden}
            isLastCell={i === days}
          />
        );
      }
    }
  }

  return (
    <>
      <div className={`date-row__month-row zoom-month-row-${zoom}`}>
        {monthRow}

        {Array.from({ length: weekInRange }).map((_, i) => {
          const weekendWidth = weekendsHidden ? 10 : getCellWidthForZoom(zoom);
          const weekWidth = getCellWidthForZoom(zoom) * 5 + weekendWidth * 2;

          return (
            <p
              key={`week-number-${i}`}
              style={{
                left: PLANNER_USER_WIDTH + weekWidth * i,
                width: getCellWidthForZoom(zoom),
              }}
              className="date-cell-header__week-number"
            >
              {getYearWeekNumber(DateTime.fromJSDate(firstPlannerDate).plus({ week: i }))}
            </p>
          );
        })}

        {zoom > 1 && <MonthName />}
        <MonthSeparator zIndex={3} />
      </div>
      <div className="date-row__date-row">
        {rows}
        <MonthSeparator />
      </div>
    </>
  );
};

DateRow.propTypes = {
  allRowsCreation: PropTypes.func,
  weekendsHidden: PropTypes.bool,
  weekendStart: PropTypes.number,
  userOrder: PropTypes.string,
  changeOrder: PropTypes.func,
};

export default DateRow;
